import axios from 'axios';
import _ from 'lodash';

const templateTypesStore = {
  state: {
    templateTypes: [],
    emailCategories: [],
    loading: false,
  },

  mutations: {
    setTemplateTypes(state, templateTypes) {
      state.templateTypes = templateTypes;
      state.loading = false;
    },

    setTemplateType(state, templateType) {
      const { templateTypes } = state;
      const index = _.findIndex(templateTypes, { id: templateType.id });

      if (index === -1) {
        templateTypes.push(templateType);
      } else {
        templateTypes[index] = templateType;
      }

      state.templateTypes = templateTypes;
      state.loading = false;
    },

    deleteTemplateType(state, id) {
      state.templateTypes = state.templateTypes.filter(templateType => templateType.id !== id);
      state.loading = false;
    },

    setEmailCategories(state, emailCategories) {
      state.emailCategories = emailCategories;
      state.loading = false;
    },

    setEmailCategory(state, emailCategory) {
      const { emailCategories } = state;
      const index = _.findIndex(emailCategories, { id: emailCategory.id });

      if (index === -1) {
        emailCategories.push(emailCategory);
      } else {
        emailCategories[index] = emailCategory;
      }

      state.emailCategories = emailCategories;
      state.loading = false;
    },

    deleteEmailCategory(state, id) {
      state.emailCategories = state.emailCategories.filter(
        emailCategory => emailCategory.id !== id,
      );
      state.loading = false;
    },

    setLoading(state, value) {
      state.loading = value;
    },
  },

  getters: {
    getTemplateTypes: state => state.templateTypes,
    getEmailCategories: state => state.emailCategories,
  },

  actions: {
    async getTemplateTypes(context) {
      try {
        const { jwtToken } = context.rootState.userStore.user.signInUserSession.idToken;
        const options = {
          headers: {
            Authorization: jwtToken,
          },
        };

        context.commit('setLoading', true);

        const templateTypes = await axios.get(`${window.BASE_API.EMAIL}/template-types`, options)
          .then(response => response.data);

        context.commit('setTemplateTypes', templateTypes);
        context.commit('setLoading', false);
      } catch (err) {
        console.error(err);
      }
    },

    createTemplateType(context, data) {
      const { jwtToken } = context.rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      context.commit('setLoading', true);

      return axios
        .post(`${window.BASE_API.EMAIL}/template-types`, data, options)
        .then((res) => {
          context.commit('setTemplateType', res.data);
          context.commit('setLoading', false);
        });
    },

    updateTemplateType(context, data) {
      const { jwtToken } = context.rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      context.commit('setLoading', true);

      return axios
        .put(`${window.BASE_API.EMAIL}/template-types/${data.id}`, data, options)
        .then((res) => {
          context.commit('setTemplateType', res.data);
          context.commit('setLoading', false);
        });
    },

    deleteTemplateType(context, id) {
      const { jwtToken } = context.rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      context.commit('setLoading', true);

      return axios
        .delete(`${window.BASE_API.EMAIL}/template-types/${id}`, options)
        .then(() => {
          context.commit('deleteTemplateType', id);
          context.commit('setLoading', false);
        });
    },

    async getEmailCategories(context) {
      try {
        const { jwtToken } = context.rootState.userStore.user.signInUserSession.idToken;
        const options = {
          headers: {
            Authorization: jwtToken,
          },
        };

        context.commit('setLoading', true);

        const emailCategories = await axios.get(`${window.BASE_API.EMAIL}/categories`, options)
          .then(response => response.data);

        context.commit('setEmailCategories', emailCategories);
        context.commit('setLoading', false);
      } catch (err) {
        console.error(err);
      }
    },

    createEmailCategory(context, data) {
      const { jwtToken } = context.rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      context.commit('setLoading', true);

      return axios
        .post(`${window.BASE_API.EMAIL}/categories`, data, options)
        .then((res) => {
          context.commit('setEmailCategory', res.data);
          context.commit('setLoading', false);
        });
    },

    updateEmailCategory(context, data) {
      const { jwtToken } = context.rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      context.commit('setLoading', true);

      return axios
        .put(`${window.BASE_API.EMAIL}/categories/${data.id}`, data, options)
        .then((res) => {
          context.commit('setEmailCategory', res.data);
          context.commit('setLoading', false);
        });
    },

    deleteEmailCategory(context, data) {
      const { jwtToken } = context.rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      context.commit('setLoading', true);

      return axios
        .delete(`${window.BASE_API.EMAIL}/categories/${data.id}`, options)
        .then(() => {
          context.commit('deleteEmailCategory', data.id);
          context.commit('setLoading', false);
        });
    },
  },
};

export default templateTypesStore;



// WEBPACK FOOTER //
// ./src/store/templateTypes/templateTypesStore.js